module.exports = __webpack_public_path__ + "static/bhbc-no-bg-2c06b2e681c66f2e2db8b38193cb9b05.png";